import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { AlertConfigPanel } from '../AlertConfigPanel';
export function AlertsPage() {
    const [selectedProject] = useState('all');
    return (_jsx("div", { className: "p-6", children: _jsx("div", { className: "max-w-7xl mx-auto", children: _jsx(AlertConfigPanel, { projectId: selectedProject }) }) }));
}
